import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.686 3.636a3.796 3.796 0 0 1 5.484.001c1.423 1.468 1.51 3.792.258 5.364h4.239c1.07 0 1.94.895 1.94 2v4c0 1.104-.87 2-1.94 2v8c0 1.104-.869 2-1.94 2H7.273c-1.071 0-1.94-.896-1.94-2v-8c-1.07 0-1.939-.896-1.939-2v-4c0-1.105.868-2 1.94-2h4.238C8.321 7.43 8.407 5.105 9.83 3.637l.155-.15a3.794 3.794 0 0 1 5.33.15q.398.414.686 1.005.285-.59.685-1.006M15.03 17H7.273v8h7.757zm9.697 0H16.97v8h7.757zm-9.697-6H5.333v4h9.697zm11.637 0H16.97v4h9.697zm-5.992-6.065a1.897 1.897 0 0 0-2.618.115c-.372.384-.688 1.29-.88 2.494-.06.366-.104.732-.136 1.083l-.027.326.317-.026q.343-.033.697-.084l.354-.056c1.168-.199 2.046-.525 2.417-.908a2.045 2.045 0 0 0 0-2.827zm-6.732.116a1.9 1.9 0 0 0-2.742 0 2.044 2.044 0 0 0 0 2.828c.371.383 1.249.71 2.417.908.355.06.71.106 1.05.14l.317.026-.026-.326a17 17 0 0 0-.081-.718l-.054-.365c-.193-1.205-.509-2.11-.88-2.493"
    />
  </svg>
);
const SvgIconGift = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconGift);
export default Memo;
